import React from 'react'
import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { IntegrationSyncDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSyncDropdown/IntegrationSyncDropdown'
import { type IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { type IIntercomSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/types'
import {
  getIntegrationContactSync,
  getIntegrationContactCreation,
  getPropertySync,
  getContactCreation,
} from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationIntercomSettingsSyncProps = {
  store: IntegrationSettingsSyncStore<IIntercomSettingsDict>
}

export const IntegrationIntercomSettingsSync: React.FC<IIntegrationIntercomSettingsSyncProps> =
  observer(({ store }) => {
    const {
      isTwoWaySync,
      setSyncType1_0,
      syncType,
      setCheckbox1_0,
      getCheckbox,
      selectItems,
      integrationName,
    } = store

    const CHECKBOXES = [
      getIntegrationContactSync('sync_update_intercom', integrationName),
      getIntegrationContactCreation('sync_save_intercom', integrationName),
    ]

    const CHECKBOXES_TWO_WAY = [
      getPropertySync('sync_update', integrationName),
      getContactCreation('sync_save', integrationName),
    ]

    return (
      <div className={styles.root}>
        <IntegrationSyncDropdown
          integrationIcon={'integrationIntercom'}
          isTwoWaySync={isTwoWaySync}
          iconHeight={30}
          syncType={syncType}
          setSyncType={setSyncType1_0}
          selectItems={selectItems}
        />

        {isTwoWaySync &&
          CHECKBOXES_TWO_WAY.map(({ field, title, label }) => (
            <TitledRow key={field} title={title} label={label} verticalAlign={'start'}>
              <Switch size='middle' value={getCheckbox(field)} onChange={setCheckbox1_0(field)} />
            </TitledRow>
          ))}
        {CHECKBOXES.map(({ field, title, label }) => (
          <TitledRow key={field} title={title} label={label} verticalAlign={'start'}>
            <Switch size='middle' value={getCheckbox(field)} onChange={setCheckbox1_0(field)} />
          </TitledRow>
        ))}
      </div>
    )
  })
